// Paths may include letters, numbers, and single (used in a row) symbols /, -, _, ., and ~
export const pathValidation =
  /^(?!.*(-{2,}|_{2,}|~{2,}|\.{2,}|\/{2,}))[A-Za-z0-9\-_.~]+(?:\/(?!.*(-{2,}|_{2,}|~{2,}|\.{2,}|\/{2,}))[A-Za-z0-9\-_.~]+)*$/;

export const domainValidation = /^(?!-)([A-Za-z0-9-]{1,63}\.)+[A-Za-z]{2,}$/;
